import { Box } from "@mui/material";
import ColorPicker from "@/components/ColorPicker";
import UIPopper from "@/components/popover";
import { useEffect, useState } from "react";

const ColorPickerPopOver = ({ color, callback, clickNode }) => {
  const [currentColor, setCurrentColor] = useState(color || "#3f51b5");
  const handleColorChange = (cl) => {
    // closePopOver(null);
    setCurrentColor(cl);
  };

  useEffect(() => {
    setCurrentColor(color);
  }, [color]);
  // const { palette } = useTheme();

  return (
    <UIPopper
      onClose={() => callback(currentColor)}
      paperStyles={{ p: 1 }}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      clickNode={clickNode}
    >
      {({ setAnchorEl }) => {
        return (
          <Box>
            <ColorPicker
              selectedColor={currentColor}
              handleChange={(e) => handleColorChange(e.hex)}
            />
          </Box>
        );
      }}
    </UIPopper>
  );
};

export default ColorPickerPopOver;
